/** Client-side photo compression: resize + JPEG so uploads stay small enough
 *  for email attachments and AI vision (target ~100-300 KB per photo). */

export type PhotoPayload = { name: string; type: string; data: string }; // data = base64, no prefix

export async function compressImage(file: File, maxDim = 1280, quality = 0.72): Promise<{ payload: PhotoPayload; preview: string }> {
  const url = URL.createObjectURL(file);
  try {
    const img = await new Promise<HTMLImageElement>((resolve, reject) => {
      const i = new Image();
      i.onload = () => resolve(i);
      i.onerror = () => reject(new Error("bad image"));
      i.src = url;
    });
    const scale = Math.min(1, maxDim / Math.max(img.width, img.height));
    const w = Math.max(1, Math.round(img.width * scale));
    const h = Math.max(1, Math.round(img.height * scale));
    const cv = document.createElement("canvas");
    cv.width = w; cv.height = h;
    cv.getContext("2d")!.drawImage(img, 0, 0, w, h);
    const dataUrl = cv.toDataURL("image/jpeg", quality);
    return {
      payload: {
        name: (file.name || "photo").replace(/\.[^.]+$/, "") + ".jpg",
        type: "image/jpeg",
        data: dataUrl.split(",")[1],
      },
      preview: dataUrl,
    };
  } finally {
    URL.revokeObjectURL(url);
  }
}
